module.exports = __webpack_public_path__ + "static/teacher-1-a00bc622aa8923e68a2341d0d5522b30.jpg";